import Loadable from "../../utils/loadable";

export default Loadable(() => import('./index'));